import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-250" data-mp="llw53zeczchy">
      <HeroSection data-id="element-251" data-mp="lnpehmgcwatn" />
      <ProofSection data-id="element-252" data-mp="2zix8zhuivi01" />
      <ProblemSection data-id="element-253" data-mp="2zjgokrwp9uaw" />
      <SystemSection data-id="element-254" data-mp="2zk8atc4eqfoi" />
      <ModulesSection data-id="element-255" data-mp="2zkrscrq5b220" />
      <BonusSection data-id="element-256" data-mp="33kig0mkdl22b" />
      <UrgencySection data-id="element-257" data-mp="33k0m3wl6qzxk" />
      <PricingSection data-id="element-258" data-mp="33lk17jv3v4xr" />
      <TestimonialsSection data-id="element-259" data-mp="33ks8qhwt1nbp" />
      <GuaranteeSection data-id="element-260" data-mp="38jlm8ac3debv" />
      <FAQSection data-id="element-261" data-mp="38jd8yhc24705" />
      <FinalCTA data-id="element-262" data-mp="38itpgw6rdak0" />
      <Footer data-id="element-263" data-mp="38iaj8cqh0alt" />
      <PurchasePopup data-id="element-264" data-mp="38hinn1wvicvj" />
    </main>;
}